// SPDX-FileCopyrightText: 2023 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2023 Netherlands eScience Center
//
// SPDX-License-Identifier: Apache-2.0

export default function TypeIcon(props:React.HTMLAttributes<HTMLOrSVGElement>) {
  return (
    <svg {...props} width="24" height="24" viewBox="-2 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H3.54286V1.65536H1.90857V13.3339H3.54286V15H0V0ZM16 15H12.4571V13.3446H14.0914V1.66607H12.4571V0H16V15Z" fill="currentColor"/>
    </svg>
  )
}
